import React from 'react';
import { Modal } from 'antd';
import SupplierForm from './SupplierForm';
import { CreateSupplierData, UpdateSupplierData, Supplier } from '../../services/supplierService';

interface SupplierModalProps {
  visible: boolean;
  supplier?: Supplier;
  onSave: (data: CreateSupplierData | UpdateSupplierData) => Promise<void>;
  onCancel: () => void;
  loading?: boolean;
}

const SupplierModal: React.FC<SupplierModalProps> = ({
  visible,
  supplier,
  onSave,
  onCancel,
  loading = false,
}) => {
  const isEdit = !!supplier;

  return (
    <Modal
      title={isEdit ? 'Cập nhật nhà cung cấp' : 'Thêm nhà cung cấp mới'}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      destroyOnClose
    >
      <SupplierForm
        supplier={supplier}
        onSave={onSave}
        onCancel={onCancel}
        loading={loading}
        noCard={true}
      />
    </Modal>
  );
};

export default SupplierModal; 